import React, { Component } from "react";
import { connect } from "react-redux";
import { getBankAccountLogs, setLoading, setDataTableFilter } from "../../../store/ducks/log/actions";
import { withNamespaces } from "react-i18next";
import DataTable from "../../../components/Datatable/DataTable";
import Swal from "sweetalert2";

class BankAccountLogListing extends Component {
    /* ======================== Component Lifecycle [START] ======================== */
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 1,
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            totalRecords: 0,
            totalPages: 0,
        };
    }

    componentDidMount() {}

    shouldComponentUpdate(nextProps, nextState) {
        // console.log("[BankAccountLogListing] shouldComponentUpdate()", "\nnextProps: ", nextProps, "\nnextState: ", nextState);

        if (nextProps.bankAccountLogData !== this.props.bankAccountLogData && nextProps.bankAccountLogData !== undefined) {
            if (nextProps.bankAccountLogData.status === 200 && nextProps.bankAccountLogData.data.msgType === "success") {
                this.setState({
                    data: nextProps.bankAccountLogData.data.data.result.row,
                    totalRecords: nextProps.bankAccountLogData.data.data.result.pagination.total_record,
                    totalPages: nextProps.bankAccountLogData.data.data.result.pagination.total_page,
                });
                this.setLoadingHandler(false, false);
            } else if (nextProps.bankAccountLogData.data && nextProps.bankAccountLogData.data.responseCode === 422) {
                this.setState({
                    data: [],
                    totalRecords: 0,
                    totalPages: 0,
                });
                if (nextProps.bankAccountLogData !== undefined && nextProps.bankAccountLogData.data.hasOwnProperty("message")) {
                    const { t } = this.props;
                    let msg = null;
                    msg = "<ul>";
                    nextProps.bankAccountLogData.data.message.forEach((val) => {
                        msg += "<li>" + val + "</li>";
                    });
                    msg += "</ul>";
                    Swal.fire({
                        icon: "error",
                        title: t("global.error"),
                        html: msg,
                        showConfirmButton: true,
                    }).then((result) => {
                        this.setLoadingHandler(true, false);
                    });
                }
            } else {
                return false;
            }
        }

        return true;
    }
    /* ======================== Component Lifecycle [END] ======================== */

    /* ======================== Datatables Function [START] ======================== */
    setLoadingHandler = (pageLoading, dataLoading) => {
        const data = {};
        data.pageLoading = pageLoading;
        data.dataLoading = dataLoading;
        this.props.setLoading(data);
    };

    getReduxFilter = () => {
        const listingArr = {};
        listingArr.page = this.state.page;
        listingArr.limit = this.state.limit;
        listingArr.order = this.state.order;
        Object.entries(this.props.filterList.filter).forEach((val) => {
            listingArr[val[0]] = val[1];
        });
        return listingArr;
    };

    fetchData = () => {
        const reduxFilterList = this.getReduxFilter();
        this.props.getBankAccountLogs(reduxFilterList);
        this.setLoadingHandler(false, true);
    };

    setDataTableFilterHandler = () => {
        const listingArr = {};
        let availablePage = this.state.page;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.page >= availablePage) && this.setState({ page: availablePage});
        }

        listingArr.page = (this.state.page >= availablePage) ? availablePage : this.state.page;
        listingArr.limit = this.state.limit;
        listingArr.order = this.state.order;
        listingArr.filter = this.props.filterList.filter;
        this.props.setDataTableFilter(listingArr);
    };

    datatablesChangeHandler = (val, act) => {
        this.setState(
            {
                [act]: val,
                data: [],
            },
            () => {
                this.setDataTableFilterHandler();
                setTimeout(() => { this.fetchData() }, 0);
            }
        );
    };

    noFormatter = (cell, row, rowIndex) => {
        // let rowNumber = (this.props.filterList.page - 1) * this.props.filterList.limit + (rowIndex + 1);
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.props.filterList.page - 1) * 10))
        return <span>{rowNumber}</span>;
    };

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = order === "asc" ? true : false;

        orderArry[0]["id"] = field;
        orderArry[0]["desc"] = orderSequence;
        this.setState({ order: JSON.stringify(orderArry) }, () => {
            this.setDataTableFilterHandler();
            this.fetchData();
        });
    };

    render() {
        const { t } = this.props;
        let dataListing = [];
        let stCls = { 0: "danger", 1: "success"};
        let stTrans = { 0: t("global.inactive"), 1: t("global.active")};
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

        /* ======================== datatables data assign [START] ======================== */
        const columns = [
            { text: t("transaction.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px" } },
            { text: t("bank-account.banks"), dataField: "bankName", sort: true, onSort: this.onSort },
            { text: t("bank-account.created_by"), dataField: "createdBy", sort: true, onSort: this.onSort },
            { text: t("global.created-time"), dataField: "createdTime", sort: true, onSort: this.onSort },
            { text: t("global.updated-time"), dataField: "updatedTime", sort: true, onSort: this.onSort },
            { text: t("global.action"), dataField: "action", sort: true, onSort: this.onSort, headerStyle: { width: "120px" } },
            { text: t("transaction.update-by"), dataField: "updatedBy", sort: true, onSort: this.onSort },
        ];
        if (!this.props.loading.pageLoading && !this.props.loading.dataLoading && this.props.bankAccountLogData.data.responseCode === 200) {
            dataListing = this.state.data.map((val, idx) => {
                let stVal = "";
                let maintainanceStVal = "";

                stVal = <span className={`badge badge-pill badge-${stCls[val.status]}`}>{stTrans[val.status]}</span>;
                maintainanceStVal = <span className={`badge badge-pill badge-${stCls[val.maintainanceStatus]}`}>{stTrans[val.maintainanceStatus]}</span>;

                return {
                    no: idx,
                    bankName: val.bankName,
                    bankCode: val.bankCode,
                    bankAccName: val.bankAccName,
                    bankAccNumber: val.bankAccNumber,
                    transactionTypeSlug: t(`transaction-type.${val.transactionTypeSlug}`),
                    status: stVal,
                    bankAccFees: val.bankAccFees,
                    minDeposit: new Intl.NumberFormat("en-US", num_format).format(val.minDeposit),
                    maxDeposit: new Intl.NumberFormat("en-US", num_format).format(val.maxDeposit),
                    maintainanceStartTime: val.maintainanceStartTime,
                    maintainanceEndTime: val.maintainanceEndTime,
                    maintainanceStatus: maintainanceStVal,
                    createdBy: val.createdBy,
                    createdTime: val.createdTime,
                    updatedTime: val.updatedTime,
                    action: val.action,
                    updatedBy: val.updatedBy,
                };
            });
        }
        return (
            <>
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header pb-0">
                            <div className="d-flex justify-content-between">
                                <h4 className="card-title mg-b-0">{t("log-type.bank-account-log")}</h4>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive table-hover datatable">
                                {!this.props.loading.pageLoading ? (
                                    <DataTable
                                        keyField="no"
                                        data={dataListing}
                                        columns={columns}
                                        activePage={this.props.filterList.page}
                                        limit={this.props.filterList.limit}
                                        totalItems={this.state.totalRecords}
                                        paginationHandler={(val) => this.datatablesChangeHandler(val, "page")}
                                        sizePerPageHandler={(val) => this.datatablesChangeHandler(val, "limit")}
                                        hideSearchBar={true}
                                        classValue="dataTable table-bordered text-justify text-center"
                                        loading={this.props.loading.dataLoading}
                                    />
                                ) : (
                                    <div className="text-center">{t("log.click-filter")}</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { log } = state;
    return {
        bankAccountLogData: log.bank_account_log_data,
        filterList: log.filterList,
        loading: log.loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBankAccountLogs: (data) => dispatch(getBankAccountLogs(data)),
        setLoading: (data) => dispatch(setLoading(data)),
        setDataTableFilter: (data) => dispatch(setDataTableFilter(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(BankAccountLogListing));
